import React from 'react';
import WabliAppBar from '../WabliAppbar/WabliAppBar';
import WabliBreadcrumb from '../WabliBreadcrumb';
import GeneralBody from '../CreateNewProject/GeneralBody';

const EditProject = () => {
    return (
      <>
        <div>
          <WabliAppBar />
          <WabliBreadcrumb name="edit project" />
          <GeneralBody isEdit={true} />
        </div>
      </>
    );
  };
  
  export default EditProject;